export const ruleLanguageSpec = {
    languageId: 'rulelang',
    keywords: ['if', 'else'],
    primitives: ['d', 's', 'b'], // number, string, boolean
    listCapableTypes: ['s'], // types that can be used in lists
    variableSigil: '$',
    typeSigil: '%',
    listMarker: '[',
    operators: [
        // arithmetic
        { id: 'eq', lexeme: '==', kind: 'cmp', arity: 2 },
        { id: 'ne', lexeme: '!=', kind: 'cmp', arity: 2 },
        { id: 'gt', lexeme: '>', kind: 'cmp', arity: 2 },
        { id: 'gte', lexeme: '>=', kind: 'cmp', arity: 2 },
        { id: 'lt', lexeme: '<', kind: 'cmp', arity: 2 },
        { id: 'lte', lexeme: '<=', kind: 'cmp', arity: 2 },
        // membership
        {
            id: 'in',
            lexeme: '<@',
            kind: 'membership',
            arity: 2,
            left: { types: ['s'], isList: false },
            right: { types: ['s'], isList: true }
        },
        {
            id: 'nin',
            lexeme: '!<@',
            kind: 'membership',
            arity: 2,
            left: { types: ['s'], isList: false },
            right: { types: ['s'], isList: true }
        },
        // logical
        { id: 'and', lexeme: '&', kind: 'logical', arity: 2 },
        { id: 'or', lexeme: '|', kind: 'logical', arity: 2 }
    ]
};
